import {certificateElementType} from "~/enums/certificateElementType";
import DynamicModeCertificateElement from "./dynamicCertificateElement";
import ImageElement from "./concerns/imageElement";

export default class DynamicModeImageCertificateElement extends ImageElement(DynamicModeCertificateElement) {
  type: certificateElementType.DynamicModeImage;

  clearRepeatableInputs() {
    //  Overwritten where needed
  }

}